<template>
  <div class="job-list">
    <h3>技能审核</h3>
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item label="一级类目">
        <el-select v-model="filter.jobCate">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in firstCates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级类目">
        <el-select v-model="filter.skillTag">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="item in secondCates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="审核状态">
        <el-select v-model="filter.showStatus">
          <el-option
            v-for="(label, value) in map.service.showStatus"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="fetch(1)" size="mini"
            >查询</el-button
          >
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="serviceTitle" label="技能名称">
        <template slot-scope="scope">
          <a
            :href="`${frontUrl}/service/detail/${scope.row.serviceId}`"
            target="_blank"
            >{{ scope.row.serviceTitle }}</a
          >
        </template>
      </el-table-column>
      <el-table-column prop="jobCate0" label="一级类目">
        <template slot-scope="scope">{{ scope.row.jobCate.name }}</template>
      </el-table-column>
      <el-table-column prop="skillTags0" label="二级类目">
        <template slot-scope="scope">{{ scope.row.skillTags.name }}</template>
      </el-table-column>
      <el-table-column label="价格">
        <template slot-scope="scope">{{
          scope.row.chargingWay === 1
            ? `${scope.row.projectPrice}元`
            : `${scope.row.hourlyRate}元/小时`
        }}</template>
      </el-table-column>
      <el-table-column prop="showStatus" label="审核状态">
        <template slot-scope="scope">
          {{ map.service.showStatus[scope.row.showStatus] }}
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="修改时间">
        <template
          slot-scope="scope"
          v-if="scope.row.updateTime !== scope.row.createTime"
          >{{ scope.row.updateTime }}</template
        >
      </el-table-column>
      <el-table-column prop="createTime" label="发布时间"></el-table-column>
      <el-table-column prop="reviseOpinion" label="未通过原因" width="300">
        <template slot-scope="scope">
          <div v-html="formatReason(scope.row.reviseOpinion)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              :disabled="scope.row.showStatus === 2"
              type="success"
              size="mini"
              @click="toggleDialog('reject', scope.row)"
              >审核未通过</el-button
            >
            <el-button
              :disabled="scope.row.showStatus === 1"
              type="success"
              size="mini"
              @click="updateStatus(scope.row, 1)"
              >审核通过</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="选择不通过原因"
      :visible.sync="dialog.reject"
      class="dialog-reject"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item>
          <el-select v-model="curData.reviseOpinion" multiple>
            <el-option
              v-for="(val, key) in reasons"
              :key="val.id"
              :value="val.reason"
              :label="val.reason"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateStatus(curData, 2)"
          >确 定</el-button
        >
        <el-button @click="toggleDialog('reject')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { service, workCateList, common } = api;

export default {
  name: "services",
  data() {
    return {
      map,
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      filter: {
        jobCate: "",
        skillTag: "",
        showStatus: 0, //  0:未审核  1：审核通过  2：审核不通过
      },
      cates: [],
      dialog: {
        reject: false,
        proposal: false,
      },
      curData: {},
      reasons: [],
      closeReason: [],
    };
  },
  components: {},
  computed: {
    firstCates() {
      return this.getCatesById(0);
    },
    secondCates() {
      return this.getCatesById(this.filter.jobCate);
    },
  },
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  mounted() {
    this.getAllTags();
    this.fetch();
    this.getReasons();
  },
  methods: {
    formatReason(data) {
      let str = "";
      if (data && data.length) {
        data.forEach((item, key) => {
          str += `${key + 1}、${item}<br>`;
        });
      }
      return str;
    },
    async getReasons() {
      let res = await common.getReasons({ type: 5 });
      if (res.data.code == 200) {
        this.reasons = res.data.data;
      }
    },
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }

      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { jobCate, skillTag, showStatus } = this.filter;

      let obj = {
        pageNum: pageNum,
        limit: limit,
        jobCate,
        skillTag,
        showStatus,
      };
      let res = await service.checkList(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    async getAllTags() {
      let {
        data: { code, data },
      } = await workCateList.getAllTags();
      if (code == 200) {
        this.cates = data.workCategory;
      }
    },
    getCatesById(id) {
      let arr = [];
      this.cates.forEach((item) => {
        if (item.parentId === id) {
          arr.push(item);
        }
      });
      return arr;
    },
    toggleDialog(name, data = {}) {
      this.dialog[name] = !this.dialog[name];
      this.curData = data;
      // this.closeReason = '';
    },
    async updateStatus(data, st) {
      let args = {
        serviceId: data.serviceId,
        showStatus: st,
        closeReason: data.reviseOpinion,
      };
      if (args.showStatus === 2 && !args.closeReason.length) {
        this.$message.error("不通过理由不允许为空");
        return false;
      }
      let {
        data: { code },
      } = await service.show(args);
      if (code == 200) {
        this.$message.success("操作成功！");
        if (args.showStatus === 2) {
          this.toggleDialog("reject");
        } else {
          this.curData = {};
        }
        this.fetch(2);
      }
    },
  },
};
</script>
<style>
.dialog-reject .el-select {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/service/checkList.vue